export class VehicleAssignStatusDTO{
    vehicleStatus:boolean;
    driverStatus:boolean;
    
    /**
     * 
     * @param vehicleStatus 
     * @param driverStatus 
     */
    constructor(vehicleStatus:boolean,
        driverStatus:boolean,){
        this.vehicleStatus = vehicleStatus;
        this.driverStatus = driverStatus;
    }
}
